import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebaseConfig"; // adjust the p
export const getAllIngredients = async () => {
  const snapshot = await getDocs(collection(db, "ingredients"));
  return snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
};
